import { Suspense, useEffect, useState } from 'react';

import { StackName, useWeb3ClientsStore } from '../store/web3-clients-store';

import { detectStack } from './utils/detectStack';

export function Web3StackProvider({ children }: { children: React.ReactNode }) {
  const { stack, setStack } = useWeb3ClientsStore();
  const [Provider, setProvider] = useState<React.ComponentType<any> | null>(null);

  // detect default stack on mount
  useEffect(() => {
    if (!stack) setStack(detectStack());
  }, [stack, setStack]);

  // lazy load and swap provider
  useEffect(() => {
    if (!stack) return;

    let active = true;
    (async () => {
      // optional: cleanup previous provider
      setProvider(null);

      if (stack === StackName.PRIVY) {
        const { default: PrivyStackProvider } = await import('./stacks/privy/privy-stack-provider');
        if (active) setProvider(() => PrivyStackProvider);
      } else if (stack === StackName.WAGMI) {
        const { default: WagmiStackProvider } = await import('./stacks/wagmi/wagmi-stack-provider');
        if (active) setProvider(() => WagmiStackProvider);
      }
    })();

    // cleanup flag to prevent setState after unmount
    return () => {
      active = false;
    };
  }, [stack]);

  if (!Provider) return <>{children}</>;

  return (
    <Suspense fallback={null}>
      <Provider>{children}</Provider>
    </Suspense>
  );
}
